<template>
  <div id="Security" class="mt-5">
    <div class="container w-75">
      <img class="rounded img-fluid h-100" src="/Seguridad.png" alt="">
    </div>
    <main class=" justify-content-center" v-if="galleryInfraestructura && gallerySecurity">
      <div class="container-fluid justify-content-center my-5">
        <div class="row justify-content-center">
          <div class="col-sm-6 col-12 ">
            <div class="card z-index-2 h-100">
              <div class="card-header pb-0 pt-3" style="position: static;">
                <h3>Infraestructura</h3>
              </div>
              <div class="card-body p-3" style="position: static;">
                <div class="justify-content-center" style="text-align: justify; position: static;">
                  <small>{{ infrastructure }}</small>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4 col-12 d-flex justify-content-center align-items-center">
            <img :src="galleryInfraestructura.images_url" class="rounded-3 w-100 h-100">
          </div>
        </div>
      </div>
      <div class="container-fluid justify-content-center my-4"
        v-if=" gallerySecurity && gallerySecurity.images_url.length > 2">
        <div class="row justify-content-center">
          <div class="col-sm-6 col-12 ">
            <div class="card z-index-2 h-100">
              <div class="card-header pb-0 pt-3">
                <h3>Auxilio Vial</h3>
              </div>
              <div class="card-body p-3">
                <div class="justify-content-center" style="text-align: justify; position: static;">
                  <small>{{ helpvial }}</small>
                  <div v-if="documents">
                    <div v-for="document in documents" :key="document.id">
                      <a target="_blank" class="text-black font-weight-bold ps-1 mb-0 icon-move-right mt-auto"
                        :href="document.file_url" v-if="document.title === 'Política de seguridad'">
                        <span>{{ document.title }} </span>
                        <i class="fas fa-arrow-right text-sm ms-1" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4 col-12">
            <div class="container">
              <div class="row">
                <img :src="gallerySecurity.images_url[2]" class="rounded-3 p-0">
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 col-12">
                <div class="d-flex justify-content-center align-items-center">
                  <!-- <div class="col text-center"> -->
                  <a target="_blank" :href="androlink"><img :src="gallerySecurity.images_url[0]"
                      class="rounded w-100 h-100"></a>
                  <!-- </div> -->
                </div>
              </div>
              <div class="col-sm-6 col-12">
                <div class="d-flex justify-content-center align-items-center pt-1">
                  <!-- <div class="col text-center"> -->
                  <a target="_blank" :href="ioslink"><img :src="gallerySecurity.images_url[1]"
                      class="rounded w-100 h-100"></a>
                  <!-- </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "security",
  data() {
    return {
      gallerySecurity: undefined,
      manageable: undefined,
      documents: undefined,
      galleryInfraestructura: undefined,
    };
  },
  props: {
    infrastructure: {
      type: String,
      request: true,
    },
    helpvial: {
      type: String,
      request: true,
    },
    androlink: {
      type: String,
      request: true,
    },
    ioslink: {
      type: String,
      request: true,
    },
  },
  methods: {
    document() {
      this.plain
        .get(`/documents`)
        .then((response) => {
          if (response.data.length !== 0) {
            this.documents = response.data;
          } else {
            this.documents = [];
          }
          // console.log(this.documents);
        })
        .catch((err) => {
          this.documents = [];
          console.log(err);
        });
    },
  },
  created() {
        this.plain
          .get(`/galleriesName?title=Aplicación`)
          .then((response) => {
            this.gallerySecurity = response.data
            // console.log(response);
          })
          .catch((err) => {
            this.gallerySecurity = undefined;
            console.log(err);
          })
      .finally(() => {
        this.plain
          .get(`/galleriesName?title=Infraestructura`)
          .then((response) => {
            this.galleryInfraestructura = response.data
            // console.log(response);
          })
          .catch((err) => {
            this.galleryInfraestructura = undefined;
            console.log(err);
          })
      })
  },
};
</script>
<style lang="scss"  scoped>
.card {
  position: static;
}

.col-sm-5 {
  position: static;
}

.col-sm-6 {
  position: static;
}

.card-body {
  position: static;
}
</style>